import { formatDateWithDayjs } from "../../../../../utils/utils";
export const COLUMNS = [
  {
    Header: "FT No.",
    Footer: "FT No.",
    accessor: "quoteId"
  },
  {
    Header: "Customer",
    Footer: "Customer",
    accessor: "customerName"
  },
  {
    Header: "Invoice Status",
    Footer: "Invoice Status",
    accessor: "invoiceStatus"
  },
  {
    Header: "Repay Date",
    Footer: "Repay Date",
    accessor: "repaymentDate",
    Cell: ({ value }) => {
      if (value) {
        return formatDateWithDayjs(value, "DD-MMM-YYYY");
      } else {
        return "";
      }
    }
  },
  {
    Header: "Balance",
    Footer: "Balance",
    accessor: "totalAmount",
    Cell: ({ value }) => {
      const formattedValue =
        value !== undefined && value !== null && value !== ""
          ? value.toFixed(2)
          : "0.00";
      return `$${formattedValue}`;
    }
  }
];
